import React from 'react';

import { Helpers } from '../core/src/helpers';	
import Countdown from '../shared/components/countdown';
import ConditionalWrapper from '../shared/components/conditional-wrapper';
import Link from '../shared/components/hyperlink';

import './top-banner.less';

export default ({ html, css, countDownEnabled, endtime, className,
    countDownFormat = "dd:hh:mm:ss", countDownMessage, bannerUrl, children, dataAttributes={}, isV2 }) => {
    countDownFormat = countDownFormat || "dd:hh:mm:ss";
    return (
        <ConditionalWrapper
            condition={!!bannerUrl}
            wrapper={children => <Link aria-label="Banner" to={bannerUrl}>{children}</Link>} >
            <div className={`top-banner${className ? ' ' + className : ''}`} {...dataAttributes}>
                <div dangerouslySetInnerHTML={Helpers.createMarkup(html)}></div>
                {children}
            </div>
            <style dangerouslySetInnerHTML={Helpers.createMarkup(css)}>
            </style>
            {
                countDownEnabled ?
                    <div className={`banner-countdown${isV2 ? ' v2' : ''}`}>
                        <div className='countdown-message'>{countDownMessage}</div>
                        <Countdown endtime={endtime} format={countDownFormat} expiredText="" />
                    </div> :
                    null
            }
        </ConditionalWrapper>
    );
};